"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var idCounter = 0;

exports.default = function (prefix) {
    var id = ++idCounter;
    return "" + prefix + id;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-toastify-redux/lib/utils/uniqueId.js
// module id = 1111
// module chunks = 0